import PropTypes from 'prop-types';

export const TConfiguratorOption = PropTypes.shape({
  choiceGroups: PropTypes.arrayOf(PropTypes.number),
  choices: PropTypes.arrayOf(PropTypes.number),
  description: PropTypes.string,
  groupSequence: PropTypes.number,
  id: PropTypes.number,
  internalName: PropTypes.string,
  isActive: PropTypes.bool,
  isDependent: PropTypes.bool,
  isHidden: PropTypes.bool,
  isIndexable: PropTypes.bool,
  isInternalOnly: PropTypes.bool,
  isRequired: PropTypes.bool,
  isVisualized: PropTypes.bool,
  longLabel: PropTypes.string,
  optionType: PropTypes.string,
  parentGroupId: PropTypes.number,
  presentationName: PropTypes.string,
  sequence: PropTypes.number,
  shortLabel: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
});

export const TConfiguratorChoice = PropTypes.shape({
  dataType: PropTypes.string,
  dependentOptions: PropTypes.arrayOf(PropTypes.number),
  fillDate: PropTypes.string,
  hasDictionaryTerm: PropTypes.bool,
  id: PropTypes.number,
  internalName: PropTypes.string,
  isActive: PropTypes.bool,
  isAvailable: PropTypes.bool,
  isBackordered: PropTypes.bool,
  isDefault: PropTypes.bool,
  isSelected: PropTypes.bool,
  longLabel: PropTypes.string,
  maxValue: PropTypes.number,
  minValue: PropTypes.number,
  mediaUrl: PropTypes.string,
  media: PropTypes.shape({
    alternateText: PropTypes.string,
    caption: PropTypes.string,
    mediaOwner: PropTypes.string
  }),
  metaDataItems: PropTypes.arrayOf(PropTypes.string),
  optionId: PropTypes.number,
  parentOptionType: PropTypes.string,
  price: PropTypes.number,
  sequence: PropTypes.number,
  shortLabel: PropTypes.string,
  siteProductOptionChoiceShortLabel: PropTypes.string,
  siteProductOptionChoiceLongLabel: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.string,
});

/* configuratorOptions returns an object keyed by optionId, allIds and topLevelOptions
    allIds and topLevelOptions are just arrays of ids
*/
export const TConfiguratorOptions = PropTypes.oneOfType(
  TConfiguratorOption,
  PropTypes.arrayOf(PropTypes.number)
);